module.exports = __webpack_public_path__ + "static/PPMori-Regular-43cfad7ee8534fdb946bc7a857cf4c24.otf";